import Vue from 'vue';
import { API_HOST } from '../constants';

/* eslint-disable camelcase */

export default {
  get(params = {}) {
    return Vue.axios.get(`${API_HOST}/share`, { params });
  },
  getId(id) {
    return Vue.axios.get(`${API_HOST}/share/${id}`);
  },
  post(params) {
    return Vue.axios.post(`${API_HOST}/share`, params);
  },
  getComment(params = {}) {
    return Vue.axios.get(`${API_HOST}/share-comment`, { params });
  },
  postComment(params) {
    return Vue.axios.post(`${API_HOST}/share-comment`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/share.js